/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useSelector } from 'react-redux';
import './Groups.less';
import { CallIcon, GroupsIcon } from '../Common/Icons';
import { Divider, Avatar } from 'antd';
import { GroupModalActions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import {
  getProfilePicUrl,
  truncateStringWith3Dots,
} from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { getProfilePics } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { UserOutlined } from '@ant-design/icons';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const GroupsScheduleCard = ({
  scheduleData,
  onGroupModalActionClick,
  setScheduleModalData,
  groupName,
}) => {
  const trans = useSelector(translator);
  const resourcesMap = useSelector(getProfilePics());
  const getStatusInfo = (status) => {
    if (!status) return { label: null, className: '' };
    const normalizedStatus = status.toLowerCase();
    switch (normalizedStatus) {
      case 'completed':
        return { label: trans('COMPLETED'), className: 'completed' };
      case 'expired':
        return { label: trans('MISSED'), className: 'expired' };
      case 'ongoing':
        return { label: trans('INPROGRESS'), className: 'ongoing' };
      case 'scheduled':
        return { label: trans('SCHEDULED'), className: 'scheduled' };
      default:
        return {
          label: status.charAt(0).toUpperCase() + status.slice(1).toLowerCase(),
          className: normalizedStatus.replace(/\s+/g, '-'),
        };
    }
  };

  const renderParticipantImages = (invitedContacts) => {
    if (!invitedContacts || invitedContacts.length === 0) {
      return null;
    }
    // Limit to first 3 contacts for display
    const displayMembers = invitedContacts.slice(0, 3);
    const hasMoreMembers = invitedContacts.length > 3;

    return (
      <>
        {displayMembers.map((contactId, index) => {
          const profileUrl = getProfilePicUrl(contactId, resourcesMap, PhotoResolution.R64);
          return (
            <Avatar
              key={contactId}
              className="participants-icon"
              src={profileUrl}
              icon={<UserOutlined />}
              style={{
                marginLeft: index === 0 ? '0' : '-20px',
                border: '2px solid #005d98',
                width: '59px',
                height: '59px',
              }}
            />
          );
        })}
        {hasMoreMembers && (
          <div
            className="participants-icon more-members-indicator"
            style={{ marginLeft: displayMembers.length === 0 ? '0' : '-20px' }}
          >
            <span className="dots-text">•••</span>
          </div>
        )}
      </>
    );
  };

  const onClickHandler = (item) => {
    onGroupModalActionClick(GroupModalActions.viewScheduleCall);
    setScheduleModalData(item);
  };

  if (!scheduleData || scheduleData.length === 0) {
    return (
      <div className="groups-list-schedule">
        <div className="no-schedule-events-container">
          <div className="no-schedule-events-message">
            {trans('THEGROUPISNEWANDHASNOTYETBEENASSIGNEDANYEVENTS')}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="groups-list-schedule">
        {scheduleData.map((item, index) => (
          <React.Fragment key={item.id}>
            {/* {index > 0 && <TimeBadgeHorizontalLine time="11:02 AM" />} */}
            <div className="groups-schedule-item" onClick={() => onClickHandler(item)}>
              <div className="groups-schedule-item-row-1">
                <div className="groups-schedule-item-block">
                  <div className="groups-event-type">
                    <CallIcon className="groups-event-type-icon" />
                    <span className="groups-event-type-label">
                      {trans(String(item.event_type).toUpperCase())}
                    </span>
                  </div>
                  <div className="group-schedule-event-name-block">
                    <span className="group-schedule-event-name-label">{item.title}</span>
                  </div>
                </div>
                <div className="groups-schedule-item-time-block">
                  <div className="groups-scheduled-event-time">{item.time}</div>
                  <div className="groups-schedule-event-status">
                    <div
                      className={`scheduled-event-status ${getStatusInfo(item.status).className}`}
                    >
                      <span className="scheduled-event-status-label">
                        {getStatusInfo(item.status).label}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="groups-schedule-item-row-2">
                <div className="groups-schedule-participants-container">
                  <div className="groups-schedule-participants-count-container">
                    <GroupsIcon />
                    <span className="participants-count">{item.members}</span>
                  </div>
                  <div className="groups-schedule-participants-image-container">
                    {renderParticipantImages(item.invited_contacts)}
                  </div>
                </div>
                <Divider className="groups-schedule-divider" type="vertical" />
                <div className="groups-schedule-repeats-container">
                  <div className="groups-schedule-repeats-label">{trans('REPEATS:')} </div>
                  <div className="groups-repeats">
                    {item.days.map((day) => (
                      <span key={day} className="groups-day">
                        <span className="groups-day-label">{trans(day.toUpperCase())}</span>
                      </span>
                    ))}
                  </div>
                </div>
                <Divider className="groups-schedule-divider" type="vertical" />
                <div className="group-schedule-information">
                  <div className="groups-schedule-typegroup">
                    <GroupsIcon className="groups-schedule-typegroup-icon" />
                    <span className="groups-schedule-typegroup-label">
                      {trans(String(item.type).toUpperCase())}
                    </span>
                  </div>
                  <span className="groups-schedule-selected-label">
                    {truncateStringWith3Dots(groupName, 70)}
                  </span>
                </div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default GroupsScheduleCard;
